import { createTheme } from '@mui/material/styles';

export const FLOW_STEPS = {
  TYPE: 'type',
  EXCEL: 'excel',
  BULLETIN: 'bulletin',
};

export const exportButtonTheme = createTheme({
  direction: 'rtl',
  palette: {
    mode: 'light',
    primary: {
      main: '#E4E9EC',
      fontFamily: 'inherit !important',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'inherit !important',
          fontSize: '0.75rem !important',
          color: '#333 !important',
          backgroundColor: '#FFF !important',
          whiteSpace: 'nowrap',
        },
      },
    },
  },
});
